<template>
  <!-- 动态单元格组件 -->
  <div>
    <el-form ref="cellForm" :model="localData" :rules="cellRules">
      <!-- 输入框 -->
      <el-form-item v-if="item.type == 'input'" :prop="item.prop" >
        <el-input size="small" :title="localData[item.prop]" v-model="localData[item.prop]"
          :placeholder="`请输入`"></el-input>
      </el-form-item>
      <!-- 下拉框 带禁选、远程搜索、修改回传-->
      <el-form-item v-else-if="item.type == 'select'" :prop="item.prop"
      :rules="item.disabled ? enableRuels(item): cellRules[item.prop]">
        <el-select size="small" v-model="localData[item.prop]" @change="emitChange"
        :disabled="item.disabled ? !localData[item.disabledKey] : false " :filterable="item.filterable"
        :remote="item.remote" :remote-method="remoteMethod" :loading="item.loading">
        <el-option v-for="(option, index) in item.options" :key="index" :value="option.value" :label="option.label"
          placeholder="请选择" />
        </el-select>
      </el-form-item>
      <!-- 下拉分组框 -->
      <el-form-item v-else-if="item.type == 'group'" :prop="item.prop" :rules="item.disabled ? enableRuels(item): cellRules[item.prop]">
        <el-select size="small" v-model="localData[item.prop]"  @change="emitChangeGroup"
        @focus="handleGroupFocus" :title="localData[item.prop]"
        :disabled="(localData.mappingType) ? false : true " :filterable="item.filterable"
        :remote="item.remote" :remote-method="remoteMethod" :loading="item.loading">
        <el-option-group v-for="(group, index) in item.options" :key="index" :label="group.label">
          <el-option v-for="(option, index) in group.options" :key="index" :value="option.value" :label="option.label"
            placeholder="请选择" />
        </el-option-group>
        </el-select>
      </el-form-item>
      <!-- 开关 -->
      <div v-else-if="item.type =='switch'" class="switch-container">
        <el-switch v-model="localData[item.prop]" @change="switchChange" />
      </div>
      <!-- 范围 -->
      <div v-else-if="item.type == 'range'" style="margin: 10px 0;">
        <el-input size="small" v-model="localData['rangeMin']" placeholder="请输入最小值" />
        <div style="line-height: 100%;">
          ~
        </div>
        <el-input size="small" v-model="localData['rangeMax']" placeholder="请输入最大值" />
      </div>
      <!-- 表单 -->
      <InjectForm v-else-if="item.type == 'form'" :formData="item.formData" :formList="item.formList" />
      <!-- 文字 -->
      <div v-else-if="item.type == 'text'">{{localData[item.prop]}}</div>
    </el-form>
  </div>
</template>

<script>
import InjectForm from '@/components/form/InjectForm.vue'
export default {
  name: 'DynamicCell',
  components: {
    InjectForm
  },
  emits: ['remote', 'switch', 'update:data', 'load', 'selected', 'emitChangeGroup', 'emitChange'],
  props: {
    // 单元格对象，包含单元格类型、属性等信息
    item: {
      type: Object,
      required: true
    },
    // 单元格数据，用于绑定和更新单元格的值
    data: {
      type: [String, Number, Array, Object, Boolean],
      required: true
    },
    // 单元格校验规则，用于表单验证
    cellRules: {
      type: Object,
      default: () => ({})
    },
    // 所有的映射表
    allMappingData: {
      type: Array,
      required: false
    },
    // 添加索引属性
    index: {
      type: Number,
      required: false
    },
    // 第几列
    column: {
      type: Number,
      required: false
    }
  },
  watch: {
    // 监听父组件的data
    data: {
      handler (val) {
        this.localData = val
      },
      deep: true
    }
  },
  computed: {
    // 计算属性，用于获取和设置本地数据，对应父组件的data
    localData: {
      get () {
        return this.data
      },
      set (val) {
        this.$emit('update:data', val)
      }
    }
  },
  methods: {
    // 开关切换事件
    switchChange (val) {
      this.$emit('switch', { data: this.localData, index: this.index, value: val })
    },
    // 远程搜索方法
    remoteMethod (query) {
      this.$emit('remote', query)
    },
    // 下拉选择改变事件
    emitChange (val) {
      console.log('下拉项的数据', val, this.column)
      const selectedOption = this.allMappingData && this.allMappingData.find(opt => opt.value === val)
      if (!selectedOption && this.column !== 3) {
        // 切换映射类别的时候，清空映射表
        this.localData.mappingName = ''
      }
      this.$emit('selected', { selectedOption, index: this.index, value: val, valueItem: val, column: this.column })
    },
    handleGroupFocus (){
      // 获取当前选中值（如果需要基于当前值处理）
      const currentValue = this.localData[this.item.prop]
      // 执行和 change 事件相同的逻辑
      const selectedOption = this.allMappingData?.find(opt => opt.value === currentValue)
      this.$emit('emitChangeGroup', { 
        selectedOption, 
        index: this.index,
        isFocus: true  // 可添加标识区分是焦点还是change触发
      })
    },
    emitChangeGroup (val) {
      const selectedOption = this.allMappingData.find(opt => opt.value === val)
      this.$emit('emitChangeGroup', { selectedOption, index: this.index })
    },
    // 表单校验方法
    handleValidation () {
      return this.$refs.cellForm.validate()
    },
    // 启用规则方法,根据disabledKey判断是否启用规则
    // disabledKey: 当disabledKey为true时，启用规则，否则禁用规则
    enableRuels (item) {
      const isRequired = this.localData[item.disabledKey]
      if (isRequired) {
        return { required: true, message: `请选择${item.label}`, trigger: 'change' }
      } else {
        return { required: false }
      }
    }
  }
}
</script>

<style scoped>
  .switch-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  /deep/ .el-switch.is-checked .el-switch__core{
    background-color: #00D8C3;
    border-color: #00D8C3;
  }

  /deep/ .el-input--small .el-input__inner {
    margin-top: 20px !important;
  }
   /deep/ .el-input.is-disabled .el-input__icon {
    margin-top: 5px !important;
  }
   /deep/ .el-select .el-input .el-select__caret{
    margin-top: 5px !important;
  }
</style>
